import { AggregateItem, TopInfluencer } from "./InsightsDashboardTop";
import { InsightsTableRow } from "./InsightsTable";
import creatorPlaceholder from "src/images/creator-placeholder.svg";
import placeholder from "src/images/placeholder-image.svg";

export const createInfluencerRows = (
  items: TopInfluencer[],
): InsightsTableRow[] =>
  items.map((item) => ({
    id: item.key,
    label: `@${item.social_username}`,
    posts: item.posts_count,
    er: item.avg_er,
    url: item.social_url,
    imageUrl: item?.profile_picture_url || null,
    fallbackImageUrl: creatorPlaceholder,
  }));

export const createAggregateRows = (
  items: AggregateItem[],
  prefix: "#" | "@",
): InsightsTableRow[] =>
  items.map((item) => ({
    id: item.key,
    label: `${prefix}${item.key}`,
    posts: item.posts_count,
    er: item.avg_er,
    imageUrl: item?.profile_picture_url || null,
    fallbackImageUrl: placeholder,
  }));
